import type { ReactNode } from 'react'
import { ShieldX } from 'lucide-react'
import { EmptyState } from '@shared/design-system/ui'
import { useSession } from '@shared/lib/auth/session-store'
import { hasAdminPermission } from '@shared/lib/auth/permissions'

type PermissionGateProps = {
  permission: string
  children: ReactNode
}

export function PermissionGate({ permission, children }: PermissionGateProps) {
  const user = useSession((state) => state.user)
  const allowed = hasAdminPermission(user, permission)

  if (!user) return null
  if (!allowed) {
    return (
      <EmptyState
        icon={<ShieldX size={22} />}
        title="Acesso restrito"
        description="Seu perfil não possui permissão para acessar esta área."
      />
    )
  }
  return children
}
